import React from "react";
import {
  ShieldIcon,
  FlameIcon,
  CheckIcon,
  BusinessIcon,
} from "../assets/icons";
import "./About.css";

const About = () => (
  <section className="about-page-structure">
    {/* ---------- HERO HEADER BANNER ---------- */}
    <div className="about-hero-image">
      <img
        src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1500&q=80"
        alt="Kafue Technologies modern operations workspace hub"
        className="about-hero-img"
      />
      <div className="about-hero-overlay">
        <div className="container text-center">
          <span className="about-mini-badge">Our Architecture</span>
          <h1 className="about-hero-title">Our Team, Your Success</h1>
        </div>
      </div>
    </div>

    {/* ---------- EXPANDED VISION TRACK ---------- */}
    <div className="container content-wrapper-about">
      <div className="section-header-center">
        <h2 className="section-title">
          About <span className="accent-text">Kafue Technologies</span>
        </h2>
        <p className="intro-text">
          More than just technology. We craft high-performance digital
          ecosystems with soul, computational strategy, and an unyielding
          standard of execution.
        </p>
      </div>

      <div className="about-grid">
        <div className="about-text-column">
          <h3 className="column-mini-heading">The Continuum</h3>
          <p>
            Based in Pretoria, South Africa, Kafue Technologies was born from a
            unified collective vision: to eliminate standard web constraints and
            deliver top-tier, secure technical engineering for forward-thinking
            brands.
          </p>
          <p>
            We operate as an agile team that deeply maps local industry dynamics
            to global software engineering standards. Our name, inspired by the
            continuous momentum of the Kafue River, symbolizes fluid connection,
            constant speed, and system adaptability.
          </p>
          <p>
            Whether developing enterprise cloud instances or sleek bespoke
            frontends, we handle your structural timeline with warmth, high
            operational craftsmanship, and complete transparency.
          </p>
        </div>

        {/* ---------- HIGH ACCORDION CORE VALUES ---------- */}
        <div className="about-values-column">
          <h3 className="values-title">Engineered Value Matrix</h3>

          <div className="value-item-card">
            <div className="value-icon-box">
              <ShieldIcon size={24} stroke="var(--sun-primary)" />
            </div>
            <div className="value-content-box">
              <h4>Trust & Structural Integrity</h4>
              <p>
                We honor our words and architectures. Every repository,
                deployment parameter, and contract timeline is built with
                absolute honesty.
              </p>
            </div>
          </div>

          <div className="value-item-card">
            <div className="value-icon-box">
              <FlameIcon size={24} stroke="var(--sun-primary)" />
            </div>
            <div className="value-content-box">
              <h4>Passion & Software Craftsmanship</h4>
              <p>
                We enforce extreme code hygiene. Creative execution and
                architectural optimization are mandatory metrics for our agency.
              </p>
            </div>
          </div>

          <div className="value-item-card">
            <div className="value-icon-box">
              <CheckIcon size={24} stroke="var(--sun-primary)" />
            </div>
            <div className="value-content-box">
              <h4>Data-Driven Outcomes</h4>
              <p>
                We measure client project success on quantifiable metrics:
                conversion expansion, asset loading optimization, and
                infrastructure scalability.
              </p>
            </div>
          </div>

          <div className="value-item-card">
            <div className="value-icon-box">
              <BusinessIcon size={24} stroke="var(--sun-primary)" />
            </div>
            <div className="value-content-box">
              <h4>African Innovation Pipeline</h4>
              <p>
                We are proud to champion and scale local tech talent,
                accelerating regional computational ecosystems to global
                standard heights.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;
